export const SET_USERS = 'setUsers'
export const SET_PAGES = 'setPages'
export const SET_GROUPS = 'setGroups'
export const SET_ROLES = 'setRoles'
export const SET_TOKEN_VALID = 'setTokenValid'
export const SET_QUIZ_DETAILS   =   'setQuizDetails'
export const SET_INDIVIDUAL_GROUP = 'setIndividualGroup'
export const SET_NAVIGATION_BAR_STATUS = 'setNavigationBarStatus'
export const SET_INDIVIDUAL_USER = 'setIndividualUser'
export const SET_INDIVIDUAL_EQUIPMENT =   'setIndividualEquipment'
export const SET_USER_DOCUMENTS =   'setUserDocuments'
export const SET_INDIVIDUAL_PAGE  =   'setIndividualPage'
export const SET_STRIPE_SECRET_KEY = 'setStripeSecretKey'
export const SET_QUIZ_DATA = 'setQuizData'
export const SET_AUTH = "setUser"
export const SET_LOGGED_IN = "setLoggedIn"
export const SET_DOCUMENTS_ERROR = 'setDocumentsError'
export const SET_INVOICES = 'setInvoices'
export const SET_LOADING = 'setLoading'
export const SET_LANGUAGES    =   'setLanguages'
export const PURGE_AUTH = 'logOut'
export const SET_STRIPE_ALL_CARDS ='setStripeAllCards'
export const SET_ROUTER_ENTER = 'setRouterEnter'
export const SET_NAVBAR_WIDTH   = 'setNavbarWidth'
export const SET_USER_STATUS = 'setUserStatus'
export const SET_ERROR_USER = 'setErrorUser'
export const SET_CUR_LANGUAGE = 'setCurrentLanguage'
export const SET_SNACKBAR   =   'setSnackbar'
export const SET_RESPONSE = 'setResponse'
export const SET_ERROR = 'setError'
export const SET_ERROR_CONTACT = 'setContactError'
export const SET_ERROR_EQUIPMENT    =   'setEquipmentError'
export const SET_ERROR_GROUPS   =   'setEquipmentGroups'
export const SET_AUTH_ERROR = 'setAuthError'
export const UPLOAD_CSV_USERS = 'uploadCsvUsers'
export const STATE_RESET    =   'stateReset'
export const RESET_STRIPE_STATE ='StripeStatereset'
export const RESET_LANGUAGES_STATE = 'StateLanguagereset'
export const RESET_USER_STATE   = 'userStateReset'
export const RESET_PAGES_STATE = 'PagesStatereset'
export const RESET_EQUIPMENTS_STATE = 'equipmentsStateReset'
export const RESET_GROUPS_STATE = 'groupsStateReset'
export const RESET_ROLES_STATE = 'rolesStateReset'
export const SET_EQUIPMENTS = 'setEquipments'
export const RESET_GLOBAL_STATE =   'globalStateReset'
export const SET_MODULES = 'setModules'
export const SET_INDIVIDUAL_MODULE = 'setIndividualModule'
export const SET_COURSES = 'setCourse'
export const SET_GENERAL_DOCUMENTS = 'setGeneralDocuments'
export const SET_PERSONAL_DOCUMENTS =   'setPersonalDocuments'
export const SET_USER_REGISTRATION_STATUS  =   'setUserRegistrationStatus'
export const SET_INBOX_SETTINGS =   'setInboxSettings'
export const SET_DOCUMENT =   'setDocument'
export const SET_LEARNING_SESSION_DATA  =   'setLearningSessionData'
export const SET_GROUP_USERS  =   'setGroupUsers'
export const SET_COMPANY_SETTINGS  =   'setCompanySettings'
export const SET_DASHBOARD_DATA   =   'setDashboardData'
export const SET_DASHBOARD_DOCUMENTS   =   'setDashboardDocuments'
export const SET_SESSION_TIME_DATA   =   'setSessionTimeData'
export const SET_DASHBOARD_QUIZ_DATA   =   'setQuizData'